import type { BadgeTone } from './ui';

/**
 * Rotulos e tons dos badges de status.
 *
 * Moram fora de ui.tsx de proposito: aquele arquivo so exporta componentes, e
 * misturar funcao pura com componente quebra o fast refresh do Vite — o modulo
 * inteiro deixa de ser elegivel e a tela recarrega do zero a cada edicao.
 */

/** Mapeia o subscriptionStatus da API para rótulo PT-BR + tom visual. */
export function subscriptionBadge(status: string): { label: string; tone: BadgeTone } {
  switch (status) {
    case 'Active': return { label: 'Ativo', tone: 'success' };
    case 'Trial': return { label: 'Trial', tone: 'warning' };
    case 'PastDue': return { label: 'Em atraso', tone: 'error' };
    case 'Cancelled': return { label: 'Cancelado', tone: 'neutral' };
    case 'Expired': return { label: 'Expirado', tone: 'error' };
    default: return { label: status, tone: 'neutral' };
  }
}

/**
 * Mapeia o status de pedido para rótulo PT-BR + tom visual.
 *
 * Os casos são exatamente os valores de `OrderStatus` serializados pela API
 * platform (nomes do enum). Rótulos para estados que o enum não tem — "Aceito",
 * "Entregue", "Recusado" — só sugeririam um fluxo que não existe.
 */
export function orderBadge(status: string): { label: string; tone: BadgeTone } {
  switch (status) {
    case 'Pending': return { label: 'Pendente', tone: 'warning' };
    case 'Preparing': return { label: 'Em preparo', tone: 'info' };
    case 'ReadyForPickup': return { label: 'Pronto', tone: 'primary' };
    case 'OutForDelivery': return { label: 'Em entrega', tone: 'primary' };
    case 'Completed': return { label: 'Concluído', tone: 'success' };
    case 'Cancelled': return { label: 'Cancelado', tone: 'error' };
    default: return { label: status, tone: 'neutral' };
  }
}

